import { memo } from "react";
import useHighRiskActions from "features/onboarding/useHighRiskActions";
import { ApplicationsTableResource } from "../common";

const HighRiskApplications = () => {
    const {
        getApplications,
        downloadCsv,
    } = useHighRiskActions();

    return (
        <ApplicationsTableResource
            fetchTableData={getApplications}
            downloadCsv={downloadCsv}
            resourceName='High Risk'
            onRowClick={() => {
                /*Stub do nothing ATM*/
            }}
        />
    );
};

export default memo(HighRiskApplications);
